import { render, staticRenderFns } from "./CommitReference.vue?vue&type=template&id=5a147eae&"
import script from "./CommitReference.vue?vue&type=script&lang=ts&"
export * from "./CommitReference.vue?vue&type=script&lang=ts&"
import style0 from "./CommitReference.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports